<script lang="ts">
  import { pwa } from '$lib/stores/pwa.js';
  import { fly, fade } from 'svelte/transition';
  import { cubicOut } from 'svelte/easing';
  import { Download, X } from 'lucide-svelte';

  const canInstall = pwa.canInstall;
  let installing = $state(false);

  async function handleInstall() {
    installing = true;
    await pwa.install();
    installing = false;
  }
</script>

{#if $canInstall}
  <div
    class="fixed inset-x-0 z-50 px-4 md:hidden"
    style="bottom: calc(5.5rem + env(safe-area-inset-bottom, 0px));"
    in:fly={{ y: 60, duration: 350, easing: cubicOut }}
    out:fade={{ duration: 200 }}
  >
    <div
      class="mx-auto flex max-w-sm items-center gap-3 rounded-2xl border border-border/50 bg-card px-4 py-3 shadow-lg"
    >
      <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-700">
        <Download class="h-5 w-5 text-white" aria-hidden="true" />
      </div>

      <div class="min-w-0 flex-1">
        <p class="text-sm font-semibold leading-tight">Install AutoPaylot</p>
        <p class="text-xs text-muted-foreground leading-tight mt-0.5">Add to your home screen for the full app experience</p>
      </div>

      <button
        class="shrink-0 rounded-full bg-brand-700 px-3.5 py-1.5 text-xs font-semibold text-white transition-all active:scale-95 disabled:opacity-50"
        onclick={handleInstall}
        disabled={installing}
      >
        {installing ? 'Installing...' : 'Install'}
      </button>

      <button
        class="shrink-0 rounded-lg p-1 text-muted-foreground transition-opacity hover:opacity-70"
        aria-label="Dismiss install prompt"
        onclick={() => pwa.dismiss()}
      >
        <X class="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  </div>
{/if}
